import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { getStationConfig, setStationConfig, clearStationConfig } from './stationConfig';

const StationContext = createContext();

export const StationProvider = ({ children }) => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    // Load saved station config on mount
    useEffect(() => {
        let cancelled = false;

        (async () => {
            const cfg = await getStationConfig();
            if (!cancelled) {
                setConfig(cfg);
                setLoading(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    const saveStation = useCallback(async (cfg) => {
        await setStationConfig(cfg);
        // Re-read so `config` reflects the normalized stored value
        const normalized = await getStationConfig();
        setConfig(normalized);
        return normalized;
    }, []);

    const clearStation = useCallback(async () => {
        await clearStationConfig();
        setConfig(null);
    }, []);

    return (
        <StationContext.Provider
            value={{
                config,
                loading,
                saveStation,
                clearStation,
            }}
        >
            {children}
        </StationContext.Provider>
    );
};

export const useStation = () => {
    const ctx = useContext(StationContext);
    if (!ctx) {
        throw new Error('useStation must be used within a StationProvider');
    }
    return ctx;
};

export default StationContext;
